/**
 * Documentation types, mirroring the fixed set used in the admin's SDK Config
 * editor (xnotify-stream-writer-frontend/src/pages/SdkConfig/sdkDocsModel.js).
 * A platform record now carries a single `type_id` — a family that needs docs
 * for more than one type (e.g. React Native: push + event + stories) is
 * multiple platform records sharing the same `label`, one per type.
 */
export const DOC_TYPES = [
    { id: 1, label: 'PUSH' },
    { id: 2, label: 'EVENT' },
    { id: 3, label: 'STORIES' },
];

export const getDocTypeLabel = (typeId) => {
    const match = DOC_TYPES.find(t => t.id === Number(typeId));
    return match ? match.label : `Type ${typeId}`;
};

/** URL/tab-safe slug for a platform family's label, e.g. "React Native" -> "react-native". */
export const slugify = (value) =>
    String(value || '')
        .toLowerCase()
        .split(/[^a-z0-9]+/)
        .filter(Boolean)
        .join('-');

/** UI-side stand-in for `variant_id: null` (object keys cannot be null). */
export const SHARED_VARIANT = '_shared';

/** Key for the flat docs map — mirrors xnotify-stream-writer-frontend/src/pages/SdkConfig/sdkDocsModel.js. */
export const docKey = (variantId) => variantId || SHARED_VARIANT;

/**
 * The admin editor saves documentation as a flat `docs: [{ variant_id, content }]`
 * list (variant_id: null = the shared/main body). Accepts either that shape or the
 * legacy one (`content` + `variants[].content`) so older platform records still render.
 */
export const normalizePlatform = (platform) => {
    if (!platform) return null;

    const docs = {};
    if (platform.docs?.length) {
        platform.docs.forEach((d) => {
            docs[docKey(d.variant_id)] = d.content || '';
        });
    } else {
        if (platform.content) docs[docKey(null)] = platform.content;
        (platform.variants || []).forEach((v) => {
            if (v.content) docs[docKey(v.id)] = v.content;
        });
    }

    return { ...platform, docs };
};
